<script lang="ts">
  import type { EnergyLabel } from "../../../types/CinemaProductsDto.types.ts";
  import EnergyLabelSheet from "./EekSheet.svelte";

  type EekLabelProps = {
    labels: EnergyLabel[];
    increasedMarginTop?: boolean;
  };

  let { labels, increasedMarginTop = false }: EekLabelProps = $props();

  /*                                                                                                                         */
  let activeLabel = $state<EnergyLabel | null>(null);

  const validLabels = $derived(
    labels.filter((label) => label.colorHexcode && label.datasheetUri),
  );
  const hasMultipleLabels = $derived(validLabels.length > 1);
</script>

<div class:increased-margin-top={increasedMarginTop} class="energy-labels">
  {#each validLabels as label}
    <div class="energy-labels__label">
      <button
        type="button"
        class="energy-labels__label-button"
        onclick={() => (activeLabel = label)}
        aria-label={`Energieeffizienzklasse ${label.category}`}
      >
        <ofc-energy-label-v1
          color={`#${label.colorHexcode}`}
          size="100"
          variant={label.category}
          version={label.version}
        ></ofc-energy-label-v1>
      </button>

      <div class="energy-labels__description">
        {#if hasMultipleLabels}
          <span class="oc-copy-50">{label.descriptor}</span>
        {/if}
        <oc-link-v2
          variant="secondary"
          size={"50"}
          base64-href={btoa(label.datasheetUri!)}
          target="_blank"
          oc-aria-label={`Produktdatenblatt ${label.descriptor}`}
        >
          Produktdatenblatt
        </oc-link-v2>
      </div>
    </div>
  {/each}
</div>

<!-- Two-way binding: this component sets activeLabel to open the sheet and EnergyLabelSheet resets it to null after closing -->
<EnergyLabelSheet bind:activeLabel />

<style lang="scss">
  @use "@otto-ec/design-tokens/tokens";

  .energy-labels {
    display: flex;
    flex-direction: column;
    gap: tokens.$oc-semantic-spacing-25;
    margin-top: tokens.$oc-semantic-spacing-50;

    &.increased-margin-top {
      margin-top: calc(#{tokens.$oc-semantic-spacing-50} + 6px);
    }

    &__label {
      display: flex;
      align-items: center;
      gap: tokens.$oc-semantic-spacing-25;
    }

    &__description {
      display: flex;
      flex-direction: column;
      align-items: flex-start;
      flex: 0 1 100%;
      text-overflow: ellipsis;
      overflow: hidden;
    }

    &__label-button {
      appearance: none;
      background: none;
      border: none;
      padding: 0;
      margin: 0;
      font: inherit;
      display: inline-flex;
      cursor: pointer;
    }
  }
</style>
